<template>
  <div class="container">
    <loading
      :active.sync="isLoading"
      :loader="'dots'"
      :color="'#FFF'"
      :background-color="'#000'"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="row">
      <div class="logo">
        <img src="monorevo_logo_fix-black.svg" />
      </div>
    </div>
    <div class="row">
      <form class="w-100" autocomplete="off" @submit.prevent="send">
        <div class="card mb-3">
          <div class="card-header">
            <h4>{{ $t("パスワードリセット")}}</h4>
          </div>
          <div class="card-body">
            <div class="form-group" style="font-size: 1.1rem; margin-bottom: 30px;">
                {{ $t("会社IDのメールアドレスに、コードを送付しました。") }}
                <br />
                {{ $t("送信されたコードと新しいパスワードを入力して下さい") }}
            </div>
            <div class="form-group">
              <label for="inputCode">{{ $t("コード") }}</label>
              <input
                type="text"
                name="text"
                class="form-control"
                autofocus
                required
                id="inputCode"
                v-model="code"
              />
            </div>
            <div class="form-group">
              <label for="inputPassword">{{ $t("パスワード") }}</label>
              <input
                type="password"
                name="password"
                id="inputPassword"
                class="form-control"
                autofocus
                maxlength="50"
                required
                v-model="password"
              />
            </div>
            <div class="form-group">
              <label for="inputPasswordConfirm">{{ $t("パスワード（確認）") }}</label>
              <input
                type="password"
                name="passwordConfirm"
                id="inputPasswordConfirm"
                class="form-control"
                autofocus
                maxlength="50"
                required
                v-model="passwordConfirm"
              />
            </div>
            <div class="form-group" style="margin: 30px auto;">
              <div class="float-left" style="width: 45%; margin-right: 10%;">
                <button type="button" class="btn btn-lg btn-light btn-block" @click="onClickCancel">
                  {{ $t("キャンセル") }}
                </button>
              </div>
              <div class="float-left" style="width: 45%;">
                <button class="btn btn-lg btn-success btn-block" type="submit">
                  &nbsp;{{ $t("リセット") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lostpasswordcode',
  data() {
    return {
      code: '',
      password: '',
      passwordConfirm: '',
      error_message: '',
      company_id: '',
      login_id: '',
      isLoading: false,
      pageTitle: 'パスワードリセット コード確認',
    }
  },
  mounted() {
    this.company_id = this.getParam('company_id')
    this.login_id = this.getParam('login_id')
    if (!this.company_id || !this.login_id) {
      // window.location.href = 'login.html'
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    onClickCancel() {
       window.location.href = this.$appConfig.ScreenUrl.login
    },
    send() {
      if (this.code && this.password === this.passwordConfirm) {
        if (this.password.length < 6) {
          this.error_message = this.$t('パスワードは6文字以上で入力して下さい')
          return
        }

        this.isLoading = true
        const credentials = {
          code: this.code,
          password: this.password,
          company_id: this.company_id,
          login_id: this.login_id,
        }
        this.$store
          .dispatch('auth/forgotPasswordSubmit', credentials)
          .then(() => {
            this.$store
              .dispatch('auth/login', credentials)
              .then(() => {
                window.location.href = 'lostpassworddone.html'
              })
              .catch(err => {
                console.log('error', err)
                this.isLoading = false
                this.error_message = this.$t(
                  'ログイン失敗'
                )
              })
          })
          .catch(err => {
            console.log('error', err)
            // TODO: パスワード変更エラー
            this.isLoading = false
            this.error_message = this.$t(
              'データ更新エラーメッセージ'
            )
          })
      } else {
        this.error_message = this.$t('パスワードが間違っています')
      }
    },
    getParam(name, url) {
      if (!url) {
        url = window.location.href
      }
      name = name.replace(/[[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/common-page.scss';
</style>
